import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a PostHog $pageview on every SPA route change — but ONLY when the
 * visitor has explicitly opted in via ConsentBanner. PostHog is initialised
 * with opt_out_capturing_by_default:true, so has_opted_in_capturing() will
 * remain false until an explicit accept, which is exactly the GDPR contract.
 */
export default function usePosthogSpaPageviews() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || !window.posthog) return;
    try {
      if (typeof window.posthog.has_opted_in_capturing === "function"
          && !window.posthog.has_opted_in_capturing()) {
        return;
      }
      window.posthog.capture("$pageview");
    } catch (_e) { /* non-blocking */ }
  }, [location.pathname]);
}
